import { CONSENT } from 'enums';
import { ConsentPolicyType } from 'interfaces/consent-status.interface';

export const POLICY_CONSENT_LABEL_KEYS: Record<ConsentPolicyType, string> = {
  [CONSENT.PRIVACY_POLICY]: 'policy_consent.policies.privacy_policy',
  [CONSENT.TERMS_OF_SERVICE]: 'policy_consent.policies.terms_of_service'
};
